import { render } from "./CreateTemplate.vue?vue&type=template&id=2f57cd9b&scoped=true"
import script from "./CreateTemplate.vue?vue&type=script&lang=js"
export * from "./CreateTemplate.vue?vue&type=script&lang=js"

import "./CreateTemplate.vue?vue&type=style&index=0&id=2f57cd9b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f57cd9b"]])

export default __exports__